import type { MarketplaceImage } from '@library/api-menu-experience'

type ProductImageCrop = {
  url?: string
  width?: number
}

type ProductImageSource = {
  title: string
  images?: MarketplaceImage[]
}

export const getProductImages = (
  product: Pick<ProductImageSource, 'images'>,
): MarketplaceImage[] => {
  if (!product.images) return []

  return product.images
}

export const getProductImageCrops = (
  product: Pick<ProductImageSource, 'images'>,
): ProductImageCrop[] =>
  getProductImages(product).reduce<ProductImageCrop[]>((crops, image) => {
    if (image.crops?.length) {
      return [...crops, ...image.crops]
    }

    return [
      ...crops,
      {
        url: image.src ?? image.url,
        width: image.width,
      },
    ]
  }, [])

const getDefaultImage = (crops: ReturnType<typeof getProductImageCrops>) => {
  const sortedCrops = crops
    .filter((crop) => crop.url)
    .sort((a, b) => (b.width ?? 0) - (a.width ?? 0))
  const midpointInArray = Math.floor(sortedCrops.length / 2)

  return sortedCrops[midpointInArray]?.url
}

const getSrcSet = (crops: ReturnType<typeof getProductImageCrops>) =>
  crops
    .filter((crop) => crop.url && crop.width)
    .map(({ url, width }) => `${url} ${width}w`)
    .join()

export const getProductImage = (product: ProductImageSource) => {
  const images = getProductImages(product)
  const crops = getProductImageCrops(product)

  return {
    alt: images[0]?.altText ?? product.title,
    src: getDefaultImage(crops),
    srcSet: getSrcSet(crops),
  }
}
